import ReactDOM from 'react-dom'

const _getMousePropValue = (e, mouseProp) => {
  return e.type.indexOf('touch') !== -1
    ? e.touches[0][mouseProp]
    : e[mouseProp]
}

export const getPositionFromEvent = (self, e) => {
  const pageX = _getMousePropValue(e, 'pageX')
  const pageY = _getMousePropValue(e, 'pageY')
  const selfEl = ReactDOM.findDOMNode(self)
  const rect = selfEl.getBoundingClientRect()

  return {
    offsetX: pageX - rect.left + selfEl.clientLeft,
    offsetY: pageY - rect.top + selfEl.clientLeft
  }
}